var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wc-row"},[_c('div',{staticClass:"wc-col"},[_c('cp-policy-quote-tile',{attrs:{"quote-id":_vm.quoteId,"is-detail-header":true}}),_c('cp-motor-details',{attrs:{"quote-id":_vm.quoteId,"partner-address-id-prop":"0","is-quote":"true"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }